var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15.5H35.0833C36.234 15.5 37.1667 16.4327 37.1667 17.5833V32.375C37.1667 34.1008 35.7675 35.5 34.0417 35.5H33.625C31.8992 35.5 30.5 34.1008 30.5 32.375V15.5Z",
    fill: "#73007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66667 3.83325C7.36548 3.83325 5.5 5.69874 5.5 7.99992V32.9999C5.5 35.3011 7.36548 37.1666 9.66667 37.1666H31.7118C31.7297 37.1666 31.7468 37.1644 31.7628 37.1606C30.128 37.0596 28.8333 35.7018 28.8333 34.0416V33.3014V17.1666V7.99992C28.8333 5.69874 26.9678 3.83325 24.6667 3.83325H9.66667ZM9.25 12.1666C9.25 11.4762 9.80965 10.9166 10.5 10.9166H23.8333C24.5237 10.9166 25.0833 11.4762 25.0833 12.1666C25.0833 12.8569 24.5237 13.4166 23.8333 13.4166H10.5C9.80965 13.4166 9.25 12.8569 9.25 12.1666ZM10.5 15.9166C9.80965 15.9166 9.25 16.4762 9.25 17.1666C9.25 17.8569 9.80965 18.4166 10.5 18.4166H23.8333C24.5237 18.4166 25.0833 17.8569 25.0833 17.1666C25.0833 16.4762 24.5237 15.9166 23.8333 15.9166H10.5ZM18.4167 26.0178L19.6162 27.2171C20.1043 27.7053 20.8957 27.7053 21.3838 27.2171C21.872 26.7289 21.872 25.9376 21.3838 25.4494L18.1978 22.2634C17.6283 21.6939 16.705 21.6938 16.1355 22.2634L12.9495 25.4494C12.4613 25.9376 12.4613 26.7289 12.9495 27.2171C13.4376 27.7053 14.2291 27.7053 14.7172 27.2171L15.9167 26.0178V30.4999C15.9167 31.1903 16.4763 31.7499 17.1667 31.7499C17.857 31.7499 18.4167 31.1903 18.4167 30.4999V26.0178Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommPublish);
export default __webpack_public_path__ + "static/media/comm_publish.ab4c12e117287b36800564ae46dd1c61.svg";
export { ForwardRef as ReactComponent };